import React from 'react';
import { useTranslation } from 'react-i18next';

const GUIDE_KEYS = [
  'onboarding.documents.profilePhotoGuide.customerSite',
  'onboarding.documents.profilePhotoGuide.close',
  'onboarding.documents.profilePhotoGuide.glasses',
  'onboarding.documents.profilePhotoGuide.helmet',
  'onboarding.documents.profilePhotoGuide.hijab',
  'onboarding.documents.profilePhotoGuide.clear',
] as const;

const ProfilePhotoGuide: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
      <p className="text-sm font-semibold text-gray-900">
        {t('onboarding.documents.profilePhotoGuide.title')}
      </p>
      <ul className="mt-2 flex list-disc flex-col gap-1.5 ps-4">
        {GUIDE_KEYS.map((key) => (
          <li
            key={key}
            className={
              key.endsWith('customerSite')
                ? 'text-sm font-medium leading-relaxed text-gray-900'
                : 'text-sm leading-relaxed text-gray-700'
            }
          >
            {t(key)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfilePhotoGuide;
